<template>
  <Modal
    :title="$t('create_measurement_unit')"
    modalId="create-modal"
    @submit="submitUnit"
    @cancel="resetForm"
  >
    <form @submit.prevent="submitUnit">
      <div class="mb-3">
        <label class="form-label">
          {{ $t('measurement_unit') }} <span class="text-danger">*</span>
        </label>
        <input
          type="text"
          v-model="units.unit"
          class="form-control"
        />
        <div v-if="errors.unit" class="text-danger mt-2">
          <span>{{ errors.unit }}</span>
        </div>
      </div>
      <div v-if="errorMessage" class="text-danger mt-2">
        {{ errorMessage }}
      </div>
    </form>
  </Modal>
</template>

<script>
import Modal from "@/components/common/Modal.vue"; // Import Modal component
import apiUrls from "../../../urls";
import {useToast} from "vue-toastification";

export default {
   components: {
      Modal,
    },

   data() {
    return {
      units: {
        unit: '',
      },
      errors: {},
      errorMessage: "",
    };
  },

  setup() {
    const toast = useToast()
    return {toast}
  },

  methods: {
      async submitUnit() {
        // Frontend validation before making API call
          this.errors = {};
          if (!this.units.unit.trim()) this.errors.unit = this.$t('error.required');

          if (Object.keys(this.errors).length > 0) {
          return; // Stop execution if validation fails
        }

        try {
          const formData = new FormData();
          Object.keys(this.units).forEach((key) => {
            formData.append(key, this.units[key]);
          });
          // Send API request
          const response = await this.$axios.post(apiUrls.measurement_unit.post, formData, {
            headers: { "Content-Type": "multipart/form-data" },
          });

          this.toast.success('Unit successfully created!')

          // Close modal after success
          const modal = document.getElementById("create-modal");
          const modalInstance = bootstrap.Modal.getInstance(modal);
          if (modalInstance) modalInstance.hide();

          // Emit event to update parent component
          this.$emit("create_success");

          this.resetForm();
        } catch (error) {
          if (error.response?.data?.error) {
            this.errorMessage = error.response.data.error;
          }

          // Handle field-specific errors dynamically
          if (error.response?.data?.errors) {
            this.errors = error.response.data.errors; // Dynamically set field errors
          }
        }
      },
      resetForm() {
      // Reset form fields and errors
      this.units.unit = "";
      this.errors = {};
      this.errorMessage = "";
    }
  },
};
</script>
